import React from "react";
import outline from "../../assets/icons/book_form-01-01.svg";
import { ChevronRight, Globe, Send } from "lucide-react";
import instagram from "../../assets/icons/instagram (2).png";
import facebook from "../../assets/icons/facebook (2).png";
import linkedin from "../../assets/icons/linkedin-sign.png";
import youtube from "../../assets/icons/play.png";

const AboutContact = () => {
  const socialMedial = [
    {
      icon: instagram,
      url: "https://www.instagram.com/dr.hemanthmakineni/",
    },

    {
      icon: facebook,
      url: "https://www.facebook.com/drhemanthmakineni/",
    },

    {
      icon: linkedin,
      url: "https://www.linkedin.com/in/hemanth-makineni-3b299752/",
    },

    {
      icon: youtube,
      url: "https://youtube.com",
    },
  ];
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative bg-[#f4f4f4] overflow-hidden">
      <div className="  bottom-0 right-0  absolute">
        <img src={outline} alt="outline" className="w-[600px] h-full" />
      </div>
      <div
        data-aos="fade-up"
        className="xl:w-[1200px] w-11/12 mx-auto flex justify-center items-center flex-col z-10"
      >
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          Get in Touch
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight px-8">
          Schedule an appointment or send your queries
        </h2>
        <div className="grid lg:grid-cols-2 grid-cols-1 w-full relative  lg:gap-10 gap-4 xl:mt-28 lg:mt-20 md:mt-16 mt-12">
          <div>
            <h3 className="text-2xl font-bold text-matcha ">
              Consult Your Doctor Online <br className="md:block hidden" />{" "}
              Anytime, Anywhere
            </h3>
            <p className="text-base text-matcha font-normal py-3 xl:w-11/12">
              Avoid long queues and unnecessary travel. Book an appointment with
              an experienced doctor and receive personalized care at your
              convenience, either in-clinic or through scheduled consultation.
            </p>
            <h4 className="text-xl font-bold text-matcha flex flex-row gap-3 mt-1 items-center">
              Your Health, Your Convenience
            </h4>
            <ul className="flex flex-col gap-2 pt-3 pb-3">
              <li className="flex flex-row items-center gap-3 text-base text-matcha font-normal">
                <span className="flex-shrink-0 w-5 h-5  bg-matcha rounded-full flex justify-center items-center">
                  <ChevronRight size={16} className="text-almond" />{" "}
                </span>{" "}
                Speak with certified specialists in real time
              </li>
              <li className="flex flex-row items-center gap-3 text-base text-matcha font-normal">
                <span className="flex-shrink-0 w-5 h-5  bg-matcha rounded-full flex justify-center items-center">
                  <ChevronRight size={16} className="text-almond" />{" "}
                </span>{" "}
                Easy appointment booking via mobile or web
              </li>

              <li className="flex flex-row items-center gap-3 text-base text-matcha font-normal">
                <span className="flex-shrink-0 w-5 h-5  bg-matcha rounded-full flex justify-center items-center">
                  <ChevronRight size={16} className="text-almond" />{" "}
                </span>{" "}
                Available 7 days a week, including evenings
              </li>
              <li className="flex flex-row items-center gap-3 text-base text-matcha font-normal">
                <span className="flex-shrink-0 w-5 h-5  bg-matcha rounded-full flex justify-center items-center">
                  <ChevronRight size={16} className="text-almond" />{" "}
                </span>{" "}
                Private, secure, and confidential consultation available
              </li>
            </ul>
            <h4 className="text-xl font-bold text-matcha flex flex-row gap-3 mt-4 items-center">
              <Globe /> Connect on Social
            </h4>
            <p className="text-base flex flex-row gap-3 text-matcha font-normal py-4">
              {socialMedial.map((item, index) => (
                <a
                  key={item.icon}
                  className="bg-matcha flex hover:bg-matcha  border-dashed border border-pistache transition justify-center items-center p-2 rounded-full"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <img src={item.icon} className="w-5 " alt="" />
                </a>
              ))}
            </p>
          </div>
          <div className="">
            <h3 className="text-xl font-bold text-matcha ">Send Message</h3>
            <form
              action=""
              className="flex  flex-col justify-between"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="mt-4 grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Full Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Your Name"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  />
                </div>
                <div>
                  <label
                    htmlFor="countries"
                    className="text-base font-bold ps-1 text-matcha"
                  >
                    Gender
                  </label>
                  <select
                    id="countries"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  >
                    <option value="Choose Option">Choose Option</option>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                  </select>
                </div>
              </div>
              <div className="mt-2 grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                {" "}
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Email
                  </label>
                  <input
                    type="email"
                    placeholder="your@gmail.com"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  />
                </div>
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Phone
                  </label>
                  <input
                    placeholder="+917894561230"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  />
                </div>
              </div>
              <div className="mt-2 grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2">
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Time
                  </label>
                  <input
                    type="time"
                    placeholder="your@gmail.com"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  />
                </div>
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Date
                  </label>
                  <input
                    type="date"
                    placeholder="+917894561230"
                    className="w-full text-base text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  />
                </div>
              </div>
              <div className="my-2 ">
                <div>
                  <label className="text-base font-bold ps-1 text-matcha">
                    Additional Message
                  </label>
                  <textarea
                    placeholder="Additional information"
                    rows={4}
                    className="w-full text-base resize-none text-matcha font-normal placeholder:text-matcha rounded-lg py-2 px-3 mt-1 bg-transparent outline-none border border-matcha focus:border-[#B87333] "
                  />
                </div>
              </div>
              <button className="bg-matcha  py-3 sm:w-40 w-full text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-lg hover:bg-transparent hover:text-matcha duration-200 transition">
                Send <Send size={20} strokeWidth={1} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContact;
